module.exports = __webpack_public_path__ + "img/home-big.17694dca.svg";